import axios from 'axios';
import BaseCrud from './baseCrud';
const crud = new BaseCrud('article');

export const state = () => ({ ...crud.state });

export const getters = {
    ...crud.getters
};

export const mutations = {
    ...crud.mutations
};

export const actions = {
    ...crud.actions,

    pin(vuexContext, id) {
        return axios.$post(`/admin/articles/${id}/pin`);
    },

    unpin(vuexContext, id) {
        return axios.$post(`/admin/articles/${id}/unpin`);
    },

    bulkShow(vuexContext, ids) {
        return axios.$get('/admin/articles/bulk-show', { params: { ids } });
    }
};
